import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  root: {
    color: colors.white,
    backgroundColor: theme.palette.primary.main,
    "&$selected, &$selected:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  gutters: {
    paddingLeft: 8,
    paddingRight: 8,
  },
  button: {
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  selected: {
    backgroundColor: theme.palette.primary.light,
  },
}));

export default useStyles;
